import React, { useContext, useState, useEffect } from 'react';
import { cloneDeep } from 'lodash';
import {
  Drawer,
  Button,
  Avatar,
  Row,
  Col,
  Space,
  Form,
  Input,
  Select,
  List,
  message,
  Divider,
  Typography,
  Collapse,
  Tooltip,
  InputNumber,
} from 'antd';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import {
  LogoutOutlined,
  EditOutlined,
  SaveOutlined,
  UserAddOutlined,
  CheckOutlined,
  WarningOutlined,
  EuroCircleOutlined,
} from '@ant-design/icons';
import { StoreContext } from '../store/index';
import { delay, getDateFromTimestamp } from '../utils';
import { auth, fcmToken } from '../firebase';
import { LEVELS, POSITION, LANGUAGES } from '../constants';
import {
  updateUser,
  removeFriend,
  fetchUserById,
  rejectRequest,
  addRequest,
} from './api';
import { addFriend } from '../shifts/api';
import { addMessagingTokenToUser } from '../login/utils';
import BallIcon from '../components/ballIcon';
import FootIcon from '../components/footIcon';

const PlayerProfileDrawer = ({ playerId, visible, onClose }) => {
  const store = useContext(StoreContext);
  const {
    user: [user, setUser, setUpdateUser],
    isUserLoading: [isUserLoading, setIsUserLoading],
  } = store;
  const { Option } = Select;
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const [form] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [player, setPlayer] = useState(null);

  useEffect(() => {
    fetchUserById(playerId, setLoading).then(data => setPlayer(data[0]));
  }, [playerId]);

  const {
    name,
    age,
    position,
    languageSelected,
    level,
    nickname,
    phoneNumber,
    role,
    photoURL,
    requests,
    createdGames,
    games,
    goals,
    absent = 0,
    tokens = 0,
  } = player || {};

  const validate = async () => {
    try {
      const values = await form.validateFields();
      return values;
    } catch (errorInfo) {
      return null;
    }
  };

  const onFormSubmit = async () => {
    const values = await validate();
    if (values) {
      const res = await updateUser(user.uid, values, setLoading);
      if (res) {
        setIsEditing(false);
      }
    }
    await delay(2000);
    setUpdateUser(true);
  };

  return (
    <Drawer
      title="Perfil"
      placement="right"
      onClose={onClose}
      extra={
        <Button
          className="width100"
          danger
          icon={<WarningOutlined />}
          loading={loading}
          onClick={() => console.log('report')}>
          {formatMessage({ id: 'profile.report' })}
        </Button>
      }
      open={visible}>
      <Space direction="vertical" className="width100" size="large">
        <Form
          name="profile"
          form={form}
          onFinish={onFormSubmit}
          layout="vertical">
          <Row justify="center">
            <Typography.Text strong>{nickname}</Typography.Text>
          </Row>
          <Row justify="center" style={{ marginTop: '8px' }}>
            <Avatar size={100} src={photoURL} />
          </Row>
          <Row justify="center">
            <Typography.Text>{phoneNumber}</Typography.Text>
          </Row>
          <Divider />
          <Row justify="center" gutter={16}>
            <Col>
              <Typography.Text>{`Edad: ${age}`}</Typography.Text>
            </Col>
            <Col>
              <Typography.Text>{`Posición: ${position}`}</Typography.Text>
            </Col>
            <Col>
              <Typography.Text>{`Nivel: ${level}`}</Typography.Text>
            </Col>
          </Row>
          <Row justify="center" align="middle" gutter={16}>
            <Col>
              <Typography.Text>
                {`Organizados: ${createdGames || 0}`}
              </Typography.Text>
            </Col>
            <Col>
              <Tooltip title={formatMessage({ id: 'player.props.games' })}>
                <Row>
                  <FootIcon size="20px" />
                  <Typography.Text>{`${games || 0}`}</Typography.Text>
                </Row>
              </Tooltip>
            </Col>
            <Col>
              <Tooltip title={formatMessage({ id: 'player.props.goals' })}>
                <Row>
                  <BallIcon size="16px" />
                  <Typography.Text>{` ${goals || 0}`}</Typography.Text>
                </Row>
              </Tooltip>
            </Col>
            <Col>
              <Typography.Text>{`Ausencias: ${absent}`}</Typography.Text>
            </Col>
            {user.isAdmin && (
              <Col>
                <Row>
                  <EuroCircleOutlined
                    style={{ fontSize: '18px', marginRight: '2px' }}
                  />
                  <Typography.Text>{tokens}</Typography.Text>
                </Row>
              </Col>
            )}
          </Row>
        </Form>
      </Space>
    </Drawer>
  );
};

export default PlayerProfileDrawer;
